<div *ngIf="posicionCampo.mostrar"
     id="dragDiv"
     #draggableDiv
     class="draggable resize"
     [ngStyle]="{'top.px': posicionCampo.top, 'left.px': posicionCampo.left, 'width.px': 200, 'height.px': 40}">
      <svg #draggableIcon class="icon-draggable">
        <use #draggableHref xlink:href="#icon-draggable"></use>
       </svg>
</div>
